<template>
  <div class="content-image-select">
    <div class="content-block">
      <label class="multiform-title">{{
        capitalizeFirstLetter(component.label)
      }}</label>

      <div class="action-buttons">
        <div>
          <v-tooltip left>
            <template v-slot:activator="{}">
              <v-btn icon color="#0eca27">
                <v-icon large>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Adicionar</span>
          </v-tooltip>
        </div>

        <div
          class="chevron-and-counter"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <v-tooltip left>
            <template v-slot:activator="{}">
              <v-btn icon color="#0eca27" @click="toggleIcon">
                <v-icon>{{
                  isDown ? 'mdi-chevron-down' : 'mdi-chevron-up'
                }}</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          <span>0</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MultiInsertForm',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDown: true,
    }
  },
  methods: {
    toggleIcon() {
      this.isDown = !this.isDown
    },

    capitalizeFirstLetter(string) {
      if (!string) {
        return ''
      }

      const firstLetter = string.charAt(0)
      const capitalizedFirstLetter = firstLetter.toUpperCase()
      const restOfString = string.slice(1)

      return capitalizedFirstLetter + restOfString
    },
  },
}
</script>
<style scoped>
.content-image-select {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.multiform-title {
  flex-grow: 1;
  font-weight: bold;
  padding-left: 5px;
  font-size: medium;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.chevron-and-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-block {
  background-color: #eeeeee;
  border: 1px solid #cccccc;
  border-radius: 8px;
  color: #69739e;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
input::placeholder {
  color: #69739e;
}
input:focus {
  outline: none;
  box-shadow: none;
}
</style>
